<div class="containerTest">
  <div class="text-center">
      <h1>Properties Challenges</h1>
  </div>
  <hr>
  <div class="card">
      <div class="card-body" style="overflow-x:auto;">
          <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="stripe hover row-border order-column">
              <thead>
                  <tr>
                    <th class="th-date">Date</th>
                    <th>Transaction ID</th>
                    <th class="th-note">Challenge Note</th>
                    <th>First Name</th>
                    <th>Middle Initial</th>
                    <th>Last Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Property Address</th>
                    <th>City</th>
                    <th>ZipCode</th>
                    <th>Building #</th>
                    <th>Owner Name</th>
                    <th>Manager Name</th>
                    <th>Contact Phone</th>
                    <th>Contact Email</th>
                    <th>Actions</th>
                  </tr>
              </thead>
              <tbody>
                  <tr *ngFor="let challenge of challenges; index as i">
                      <td [attr.data-sort]="sortDate(challenge.created)">{{ challenge.created | date }}</td>
                      <td style="white-space: nowrap">{{ challenge.transactionID }}</td>
                      <td [innerHtml]="(challenge.notes | multiline)"></td>
                      <td>{{ challenge.fromUser?.firstName }}</td>
                      <td>{{ challenge.fromUser?.middleInitial }}</td>
                      <td>{{ challenge.fromUser?.lastName }}</td>
                      <td>{{ challenge.fromUser?.email }}</td>
                      <td>{{ challenge.fromUser?.phone }}</td>
                      <td>{{ challenge.address }}</td>
                      <td>{{ challenge.city }}</td>
                      <td>{{ challenge.zipCode }}</td>
                      <td>{{ challenge.buildingNumber || 1 }}</td>
                      <td>{{ challenge.property?.ownerName }}</td>
                      <td>{{ challenge.property?.managerName }}</td>
                      <td>{{ challenge.property?.contactPhone }}</td>
                      <td>{{ challenge.property?.email }}</td>
                      <td class="td-actions">
                        <button (click)="deleteChallenge(i)" class="btn-danger"><mdb-icon fas icon="trash"></mdb-icon></button>
                      </td>
                  </tr>
              </tbody>
          </table>
      </div>
  </div>
</div>
